import client from '../api/client';
import { User, UserRole, EntityStatus } from '../types/entities';

export interface CreateUserInput {
  username: string;
  email?: string;
  password: string;
  role: UserRole;
  driverId?: number;
}

export interface UpdateUserInput {
  username?: string;
  email?: string;
  role?: UserRole;
  status?: EntityStatus;
  driverId?: number;
}

export interface UserListParams {
  role?: UserRole;
  status?: EntityStatus;
  search?: string;
}

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

class UserService {
  async list(params?: UserListParams): Promise<User[]> {
    const queryParams = new URLSearchParams();
    if (params?.role) queryParams.append('role', params.role);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.search) queryParams.append('search', params.search);

    const query = queryParams.toString();
    const response = await client.get(`/users${query ? `?${query}` : ''}`);
    return response.data.data;
  }

  async getById(id: number): Promise<User> {
    const response = await client.get(`/users/${id}`);
    return response.data.data;
  }

  async create(data: CreateUserInput): Promise<User> {
    const response = await client.post('/users', data);
    return response.data.data;
  }

  async update(id: number, data: UpdateUserInput): Promise<User> {
    const response = await client.put(`/users/${id}`, data);
    return response.data.data;
  }

  async delete(id: number): Promise<void> {
    await client.delete(`/users/${id}`);
  }

  async resetPassword(id: number, newPassword: string): Promise<void> {
    await client.post(`/users/${id}/reset-password`, { newPassword });
  }

  async changePassword(data: ChangePasswordInput): Promise<void> {
    await client.post('/auth/change-password', data);
  }

  async getAvailableDrivers(): Promise<Array<{ id: number; name: string; phone?: string }>> {
    const response = await client.get('/users/available-drivers');
    return response.data.data;
  }
}

export const userService = new UserService();